export const defaultLdJson = {
  '@context': 'http://schema.org',
  '@type': 'Organization',
  name: 'Baija',
  url: 'https://baija.pl',
  telephone: '+48 33 445 42 45',
  email: 'info@baija.pl',
  areaServed: ['PL', 'EN'],
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+48 33 445 42 45',
    contactType: 'customer service',
    availableLanguage: {
      '@type': 'Language',
      name: ['English', 'Polish'],
      alternateName: ['en', 'pl'],
    },
  },
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Bielsko-Biała',
    postalCode: '43-300',
    streetAddress: 'Bystrzańska 70',
  },

  sameAs: [
    'https://www.facebook.com/baijapl',
    'https://www.instagram.com/baijapl/',
  ],
};
